import {
    ADD_CUSTOMER_FORM_CHANGE,
    ADD_CUSTOMER_FORM_CLEAR,
    SET_CUSTOMER_LIST
} from '../types';
import customer from '../../api/DataObjects/customer';

const INITIAL_STATE = {
    addForm: new customer(),
    list: []
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ADD_CUSTOMER_FORM_CHANGE:
            if (action.subtype)
                return { ...state, addForm: { ...state.addForm, [action.subtype]: { ...state.addForm[action.subtype], [action.name]: action.payload } } }
            else
                return { ...state, addForm: { ...state.addForm, [action.name]: action.payload } }
        case ADD_CUSTOMER_FORM_CLEAR:
            return { ...state, addForm: new customer() }
        case SET_CUSTOMER_LIST:
            return { ...state, list: action.payload }
        default:
            return state;
    }
}
